import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/sections/PageHero";
import { LeadSection } from "@/components/sections/LeadSection";
import { EASE, Reveal } from "@/components/motion/Reveal";
import { INDUSTRIES, IMG } from "@/data/site";
import { scrollToTarget } from "@/lib/lenis";
import { cn } from "@/lib/utils";
import { ParallaxImg } from "@/components/fx/Motion";

const Row = ({ it, i }) => (
  <div className="grid items-center gap-10 border-t border-white/5 py-16 lg:grid-cols-12 lg:py-24" data-testid={`industry-row-${it.slug}`}>
    <motion.div
      initial={{ clipPath: "inset(0 100% 0 0 round 28px)" }}
      whileInView={{ clipPath: "inset(0 0% 0 0 round 28px)" }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1.3, ease: EASE }}
      className={cn("relative h-[320px] overflow-hidden sm:h-[440px] lg:col-span-7", i % 2 && "lg:order-2 lg:col-start-6")}
    >
      <ParallaxImg src={it.img} alt={it.title} amount={12} />
      <div className="absolute inset-0 bg-gradient-to-t from-ink-950/60 to-transparent" />
    </motion.div>
    <Reveal className={cn("lg:col-span-4", i % 2 ? "lg:order-1 lg:col-start-1" : "lg:col-start-9")}>
      <span className="font-mono text-xs text-volt">0{i + 1}</span>
      <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">{it.title}</h2>
      <p className="mt-5 text-base leading-relaxed text-slate-400">{it.blurb}</p>
      <ul className="mt-6 space-y-2">
        {it.picks.map((p) => (
          <li key={p} className="flex items-center gap-3 text-sm text-slate-200"><span className="h-1.5 w-1.5 rotate-45 bg-volt" /> {p}</li>
        ))}
      </ul>
      <button onClick={() => scrollToTarget("#get-started")} className="btn-ghost mt-8 h-11 px-5 text-sm" data-testid={`industry-cta-${it.slug}`}>
        Get options for {it.title.toLowerCase()} <ArrowRight className="btn-arrow h-4 w-4" />
      </button>
    </Reveal>
  </div>
);

export default function IndustriesPage() {
  return (
    <div data-testid="industries-page">
      <PageHero testId="industries-hero" eyebrow="Industries" lines={["Built for", "Your Business"]} img={IMG.bar} sub="Restaurants, bars, bowling centers, convenience stores, arcades and entertainment centers — each gets equipment matched to how its customers spend time." />
      <section className="pb-10">
        <div className="container-x">
          {INDUSTRIES.map((it, i) => (
            <Row key={it.slug} it={it} i={i} />
          ))}
        </div>
      </section>
      <LeadSection index="07" source="industries-page" />
    </div>
  );
}
